<template>
  <div>
    <Input
      label="global.password"
      v-model="form.password"
      :state="validateState('password')"
      :errorMessage="validatePassword()"
    />
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'StashUserUpdateForm',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selectedStashUser: '',
  },
  data() {
    return {
      form: {
        password: '',
      },
      loading: false,
    }
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validatePassword() {
      if (this.form.password) {
        if (this.form.password.length < 3)
          return this.$t('errors.minLenght').replace('{0}', 3)
      } else return this.$t('errors.notEmpty')
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        password: this.form.password,
      }

      ApiService.put(`/stash/users/${this.selectedStashUser.id}`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.$v.$reset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
